import * as React from "react";
import type { SVGProps } from "react";
const SvgMapPinsOnRoute = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 7c-.13 0-.26-.03-.38-.08-.13-.05-.23-.12-.33-.21C5.11 6.52 5 6.26 5 6c0-.26.11-.52.29-.71.1-.09.21-.16.33-.21a1 1 0 0 1 .76 0c.13.05.23.12.33.21.19.19.29.45.29.71 0 .26-.1.52-.29.71-.09.09-.2.16-.33.21-.12.05-.25.08-.38.08Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 12c-.24 0-.49-.09-.68-.26C4.98 11.43 2 8.6 2 6c0-2.13 1.87-4 4-4s4 1.87 4 4c0 2.6-2.98 5.42-3.32 5.74-.19.18-.43.26-.68.26Zm0-8C4.86 4 4 5.06 4 6c0 1.12 1.15 2.63 2 3.57C6.95 8.53 8 7.04 8 6c0-.94-.86-2-2-2Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18 10c-.26 0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71 0-.26.11-.52.29-.71.1-.09.21-.16.33-.21a1 1 0 0 1 .76 0c.12.05.23.12.33.21.18.19.29.45.29.71 0 .26-.11.52-.29.71-.1.09-.21.16-.33.21-.12.05-.25.08-.38.08Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.32 14.74c.19.17.44.26.68.26.25 0 .49-.08.68-.26C19.02 14.42 22 11.6 22 9c0-2.13-1.87-4-4-4s-4 1.87-4 4c0 2.6 2.98 5.43 3.32 5.74ZM16 9c0-.94.86-2 2-2 1.14 0 2 1.06 2 2 0 1.04-1.05 2.53-2 3.57-.85-.94-2-2.45-2-3.57Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M9 17c-.13 0-.26-.03-.38-.08s-.23-.12-.33-.21c-.04-.05-.08-.1-.12-.16a.556.556 0 0 1-.09-.17.636.636 0 0 1-.06-.18.645.645 0 0 0-.01-.1c-.005-.033-.01-.065-.01-.1 0-.26.11-.52.29-.71.1-.09.21-.16.33-.21a1 1 0 0 1 .76 0c.13.05.23.12.33.21.09.1.16.21.21.33.06.12.08.25.08.38 0 .26-.11.52-.29.71-.1.09-.2.16-.33.21-.12.05-.25.08-.38.08Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.32 21.74c.19.17.44.26.68.26.25 0 .49-.08.68-.26C10.02 21.42 13 18.6 13 16c0-2.13-1.87-4-4-4s-4 1.87-4 4c0 2.6 2.98 5.43 3.32 5.74ZM7 16c0-.94.86-2 2-2 1.14 0 2 1.06 2 2 0 1.04-1.05 2.53-2 3.57-.85-.94-2-2.45-2-3.57Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M10.62 9.92c.12.06.25.08.38.08s.26-.02.38-.08c.13-.05.23-.12.33-.21.19-.19.29-.45.29-.71 0-.06 0-.13-.02-.19a.603.603 0 0 0-.06-.19.556.556 0 0 0-.09-.17c-.022-.044-.055-.083-.087-.12a1.49 1.49 0 0 1-.033-.04c-.1-.09-.2-.16-.33-.21a1 1 0 0 0-.76 0c-.12.05-.23.12-.33.21-.04.05-.08.1-.12.16-.04.05-.07.11-.09.17-.03.06-.05.12-.06.19-.02.06-.02.13-.02.19 0 .26.11.52.29.71.1.09.21.16.33.21ZM13 12c-.13 0-.26-.03-.38-.08s-.23-.12-.33-.21c-.18-.19-.29-.45-.29-.71 0-.26.11-.52.29-.71.1-.09.21-.16.33-.21.36-.15.81-.06 1.09.21.18.19.29.45.29.71 0 .26-.11.52-.29.71-.19.18-.45.29-.71.29ZM13.62 21.92c.12.06.25.08.38.08.26 0 .52-.11.71-.29.18-.19.29-.45.29-.71 0-.26-.11-.52-.29-.71-.28-.28-.73-.37-1.09-.21-.12.05-.23.12-.33.21-.18.19-.29.45-.29.71 0 .26.11.52.29.71.1.09.21.16.33.21ZM18 18c-.26 0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71 0-.26.11-.52.29-.71.1-.09.21-.16.33-.21a1 1 0 0 1 .76 0c.13.05.23.12.33.21.18.19.29.45.29.71 0 .26-.11.52-.29.71-.1.09-.21.16-.33.21-.12.06-.25.08-.38.08ZM15.62 19.92c.12.06.25.08.38.08.26 0 .52-.11.71-.29.19-.19.29-.45.29-.71 0-.26-.1-.52-.29-.71a.999.999 0 0 0-1.09-.21c-.12.05-.23.12-.33.21-.18.19-.29.45-.29.71 0 .26.11.52.29.71.1.09.21.16.33.21Z"
    />
  </svg>
);
export default SvgMapPinsOnRoute;
